import { safeParseJSON } from "@/utils/File-parsers/safeParseJSON";
import { EvidenceFormData } from "../../evidence.types";
import CustomAttribute from "@/types/CustomAttribute";

/**
 * Transform custom_attributes array into individual form field properties
 */
export const transformCustomAttributes = (data?: EvidenceFormData) => {
  if (!data?.custom_attributes) return {};

  const customFieldValues: Record<string, string | number | string[] | null> =
    {};
  data.custom_attributes.forEach((attr: CustomAttribute) => {
    // Handle TagBox fields that store values as JSON strings
    if (attr.editor_type === "tagBox") {
      customFieldValues[`custom_attribute_${attr.field_id}`] = Array.isArray(
        attr.value
      )
        ? attr.value
        : safeParseJSON(attr.value || "[]");
    } else {
      customFieldValues[`custom_attribute_${attr.field_id}`] =
        attr.value ?? null;
    }
  });

  return customFieldValues;
};

/**
 * Process custom attributes from form data into API format
 */
export const processCustomAttributesForAPI = (
  formData: Record<string, unknown>
): Array<{ field_id: number; value: string | number | string[] | null }> => {
  const customAttributes: Array<{
    field_id: number;
    value: string | number | string[] | null;
  }> = [];

  for (const key in formData) {
    if (key.indexOf("custom_attribute_") !== -1) {
      customAttributes.push({
        field_id: parseInt(key.replace("custom_attribute_", "")),
        value: formData[key] as string | number | string[] | null,
      });
      delete formData[key];
    }
  }

  return customAttributes;
};

/**
 * Helper function for array comparison
 */
export const arraysEqual = (arr1: unknown[], arr2: unknown[]): boolean => {
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};
